<!--BEGIN CONTENT-->
@if (!noDevices) {
<div id="toggleRow" class="row no-gutters nav-tabs align-items-center action-row">
  <!-- back column -->
  <div class="col-md-1 col-sm-2 pl-2 animated fadeIn">
    <!-- <a class="link-color text-bold" style="cursor: pointer;" (click)="back()">
      <i class="fa fa-chevron-left"></i> Back
    </a> -->
  </div>
  <!-- toggles column -->
  <div class="col-md-2 col-sm-10 vehicle-select">
    <div class="row">
      <!-- trips view toggle -->
      <div class="col-md-5 no-gutters togglediv">
        @if (permissionModules.includes('TRIPS')) {

          <ng-template #TripTooltip>
            <div class="text-left" style="width: 580px;">
              <h6>Trips</h6>
              <p>
                If enabled, the data will be displayed as individual trips. <br>
                If disabled, the data displayed will be over the given time period based on the selections on the upper right of the screen. <br>
              </p>
            </div>
          </ng-template>
          <label class="toggler d-inline">Trips &nbsp; </label>
          <label class="toggle-switch m-0" [ngbTooltip]="TripTooltip" placement="top" container="body" tooltipClass="custom-wide-tooltip">
            <input
              type="checkbox"
              name="toggle-ingestionTimeStamp"
              autocomplete="off"
              [checked]="false"
              (change)="goToTrips()"
            />
            <span class="toggle-switch-slider round"></span>
          </label>
        
}
      </div>
      <!-- latency plot toggle -->
      <div class="col-md-7 no-gutters togglediv">
        <ng-template #LatencyTooltip>
          <div class="text-left" style="width: 580px;">
            <h6>Network Latency</h6>
            <p>
              If disabled, the map will display a line based on the data displayed. <br>
              If enabled, each data element displayed will have a corresponding dot on the map to show upload latency based on the events trigger time and the time the server received the event. <br>
            </p>
          </div>
        </ng-template>
        <label class="toggler d-inline">Network &nbsp; </label>
        <label class="toggle-switch m-0" [ngbTooltip]="LatencyTooltip" placement="right" container="body" tooltipClass="custom-wide-tooltip">
          <input
            type="checkbox"
            name="toggle-ingestionTimeStamp"
            autocomplete="off"
            [checked]="dottedEvents.checked"
            (change)="switchMap()"
          />
          <span class="toggle-switch-slider round"></span>
        </label>
      </div>
    </div>
  </div>
  <!-- groups, messages, device and calendar column -->
  <div class="col-md-9 col-sm-12 text-right select-operations">
    <!-- group name display -->
    <span class="btn btn-custom groupBtn disabled mr-1" ngbTooltip="Group: {{vehicle.groupName}}">
      Group: {{vehicle.groupName}}
    </span>
    <!-- message type select dropdown -->
    <div class="d-inline-block message-select ng-select-row mr-1" style="width: 13rem;">
      <ng-select
        [items]="messageTypeArray"
        bindLabel="displayName"
        bindValue="messageType"
        [multiple]="false"
        [closeOnSelect]="true"
        name="messageType"
        #messageType="ngModel"
        [(ngModel)]="searchModel.messageType"
        (change)="getFilteredMessage()"
        class="btn btn-custom p-0 text-left"
        placeholder="Select Message">
      </ng-select>
    </div>
    <!-- device select dropdown -->
    <div class="d-inline-block mr-1" style="width: 14rem;">
      <app-search-select-vehicle
        (vehicleChangeEvent)="changeVehicle($event)"
        [autoSelect]="true"
        [clearable]="false"
        [querySelectVehicle]="querySelectVehicle"
        >
        </app-search-select-vehicle>
    </div>
    <!-- calendar date time select -->
    <div class="d-inline-block mr-1" (clickOutside)="hideCalendar=!hideCalendar;">
      <app-date-time-calendar
        [clickOutside]="hideCalendar"
        [selectPreset]="'eventTime'"
        [displayEventTime]="{start: vehicle.startTime, end: vehicle.endTime}"
        [maxRangeDays]="1"
        [validateHours]="24"
        [vehicle]="vehicle.deviceId"
        [singlySelectedVehicle]="true"
        [hideLinks]="['7days', '30days', 'week', 'month', 'todaysofar', 'weektodate', 'monthtodate', '90days', '180days', '365days']"
        (timeChangeEvent)="onTimeChange($event)"
      >
      </app-date-time-calendar>
    </div>
    <!-- <a (click)="getallReports();" class="dropdown-toggle reports-dropdown btn btn-icon ml-1" href="#" role="button"
       id="dropdownMenuLink" data-toggle="dropdown"
       tooltip="Go To Reports"
       placement="top"
       aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-bar-chart"></i>
      <span class="mob-access-text d-none">&nbsp;Go to Report</span>
    </a>
    <div class="dropdown-menu reports" aria-labelledby="dropdownMenuButton">
      <div *ngIf="customLoader" class="text-center tooltip-address-text">
        <img src="../../../assets/img/darby_loader_small.gif"/>
      </div>
      <form #f="ngForm">
        <input
          #reportSearch type="text"
          class="form-control p-2"
          placeholder="Search Report"
          (click)="$event.stopPropagation();"
          (keyup)="filterReport($event)"
        />
      </form>
      <span
        (click)="redirectToReports(data)"
        *ngFor="let data of reports"
        class="dropdown-item cursor-pointer" href="#">
        <i class="fa fa-bar-chart report-icon"></i> {{data.name}}
      </span>
      <span class="dropdown-item text-center" *ngIf="!reports.length" href="#">
        <b>No reports found</b>
      </span>
    </div>
    <button
      class="btn btn-icon ml-1 filter-button"
      (click)="togglePlacesFilter()"
      tooltip="Filter Places"
      placement="top"
      >
      <i [class.text-danger]="filterplace" class="fa fa-filter" aria-hidden="true"></i>
      <span class="mob-access-text d-none">&nbsp;Filter</span>
    </button>
    <button
      *ngIf="viewPage"
      class="btn btn-icon mx-1"
      tooltip="Download CSV"
      placement="top"
      (click)="downloadViewPage()">
      <i class="fa fa-cloud-download"></i>
    </button> -->
  </div>
</div>
}
<div class="row no-gutters" style="border-bottom: 1px solid lightgray; min-height: 42px;">
  <ul class="col-md-12 nav detailed-tabs relative page-sub-heading" style="padding: 3px 12px;" role="tablist">
    <app-time-seeker [selectedDevice]="vehicle.deviceId" [tsTime]="startTime" [teTime]="endTime"
          (onTimeSel)="onTimeSelection($event)"></app-time-seeker>
  </ul>
</div>
@if (noDevices) {
<div class="col-md-12" style="height: 64vh;">
  <div class="text-center my-8 pb-5">
    <img width="170" src="../../../assets/img/info_nodata_256.png"/>
    <h4 class="mt-3">No data to show</h4>
  </div>
</div>
}
<!-- table and map row -->
<div class="row px-2" id="mapdiv">
  <!-- table column -->
  <!-- (scroll)="onScroll($event)" -->
  <div class="col-md-4 pr-0 smooth">
    <div class="left-sec">
      <div class="pid-label" (click)="triggerDynamicService(0);" id="tripView" [class.active]="currentView === 0">
        Message View
        <div class="arrow">
          <!-- <img [class.active-arr]="currentView === 0" src="../../../../assets/img/up-arrow.svg"> -->
          <i class="fa fa-plus-circle fa-lg" [class.fa-minus-circle]="currentView === 0" aria-hidden="true"></i>
        </div>
      </div>
      <div class="" id="leftCol1" style="overflow-y: auto !important;" [ngStyle]="{'display': ((currentView === 0) ? 'block' : 'none')}">
        <!-- distance and shortcut actions row -->
        @if (!noDevices) {
<div class="row no-gutters align-items-center">
          <!-- distance display column -->
          <div class="col-md-6 pl-1 animated fadeIn">
            @if (locationVehicles) {
<div class="events-div div1 m-1">
              <span class="title distance-title">Distance</span>
              <span class="title distance-title">
                {{ totalDistanceTravelled | distanceMetricspipe }}
                <small class="">{{ distanceMetrics }}</small>
              </span>
              <!-- <h5 class="value distance-value">
              </h5> -->
            </div>
}
          </div>
          <!-- shortcut column -->
          <div class="col-md-6 text-right pr-2 animated fadeIn">
            @if (permissionModules.includes('REPORT')) {
<button class="btn btn-icon mx-1" ngbTooltip="Go to reports"
              placement="top" (click)="showReportsModal()">
              <i class="fa fa-bar-chart"></i>
            </button>
}
            <button class="btn btn-icon ml-1 filter-button" (click)="togglePlacesFilter()" ngbTooltip="Filter Places"
              placement="top">
              <i [class.text-danger]="filterplace" class="fa fa-filter" aria-hidden="true"></i>
              <span class="mob-access-text d-none">&nbsp;Filter</span>
            </button>
            @if (viewPage) {
<button class="btn btn-icon mx-1" ngbTooltip="Download CSV" placement="top"
              (click)="downloadViewPage()">
              <i class="fa fa-cloud-download"></i>
            </button>
}
            <!-- <div class="events-div m-1" *ngIf="alerts">
              <span class="title events-title">Events</span>
              <ul class="value events-values list-inline">
                <li *ngFor="let data of alerts">
                  <div [tooltip]="data.alertName" placement="top" *ngIf="data.themeName">
                    <span [class]="data.themeName">{{ data.count }}</span>
                  </div>
                  <div [tooltip]="data.alertName" placement="top" *ngIf="!data.themeName">
                    <span class="themeDefault">{{ data.count }}</span>
                  </div>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
}
        <!-- table row -->
        <div class="row no-gutters m-0 liveTable">
          <div class="col-md-12">
            @if (historyRows.length) {
<ngx-datatable #table
              class="bootstrap alertTable reportsTable wrapcell historyTable animated fadeIn location-hisory-ngxtable"
              [loadingIndicator]="loadingIndicator" [rows]="historyRows" [columns]="" [columnMode]="'force'"
              [headerHeight]="20" [footerHeight]="historyRows.length > 10 ? 50 : 0" [limit]="pageInfo.limit"
              [offset]="pageInfo.offset" [count]="pageInfo.count" [rowHeight]="30" [summaryRow]="false" [scrollbarH]="true"
              [scrollbarV]="false" (page)="pageCallback($event)" [reorderable]="true">
              <ngx-datatable-column [resizeable]="false" name="Event Time" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.eventTime | date: dateFormat }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [resizeable]="false" name="Ingestion Time" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.ingestionTimestamp | date: dateFormat }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [resizeable]="false" name="Activity" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  @if (row.messageId) {
<a (click)="getMessageJSON(row.messageId);" data-toggle="modal"
                    data-target="#messageJSON">
                    <span class="success">{{ row.activity }}</span>
                  </a>
}
                  @if (!row.messageId) {
<a class="place-activity-cursor">
                    @if (!row.messageId) {
<span>{{ row.activity }}</span>
}
                  </a>
}
                </ng-template>
              </ngx-datatable-column>
              <!-- <ng-container *ngFor="let data of livehistorySearchheader">
                <ngx-datatable-column
                  *ngIf="data.key != 'eventType' && data.key != 'address'"
                  [resizeable]="false"
                  name="{{ data.displayName }}"
                  >
                  <ng-template ngx-datatable-header-template>
                    <span>{{ data.displayName }}</span>
                  </ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row[data.key] }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column *ngIf="data.key == 'address'">
                  <ng-template ngx-datatable-header-template>Address</ng-template>
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="tooltip-address" *ngIf="row[data.key] != undefined">
                      <span class="text-ellipsis">{{ row[data.key] }}</span>
                      <span class="tooltip-address-text">{{ row[data.key] }}</span>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
              </ng-container> -->
            </ngx-datatable>
}
            @if (locationTotalCount && locationTotalCount.count && historyRows.length) {
<div class="total-count"
              style="bottom: -20px;">
              Showing
              <span>
                {{ currentPageCount.start }}
              </span>
              -
              <span>
                {{ currentPageCount.end }}
              </span> of {{ locationTotalCount.count }} results.
            </div>
}
            @if (historyRowsEmpty) {
<div class="text-center my-5 pb-5">
              <img width="170" src="../../../assets/img/info_nodata_256.png" />
              <h4 class="mt-3">No data to show</h4>
            </div>
}
          </div>
        </div>
      </div>
    </div>
    <div class="left-sec">
      <div class="pid-label" (click)="triggerDynamicService(1);" id="pidView" [class.active]="currentView === 1">
        Data View
        <div class="arrow">
          <!-- <img [class.active-arr]="currentView === 1" src="../../../../assets/img/up-arrow.svg"> -->
          <i class="fa fa-plus-circle fa-lg" [class.fa-minus-circle]="currentView === 1" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-12 p-0" [ngStyle]="{'display': ((currentView === 1) ? 'block' : 'none')}" id="leftCol2">
        <app-obd-pid-view [isHistoryToggleOn]="false" [selectedDevice]="vehicle" [tsTime]="startTime" [teTime]="endTime" [activeTab]="currentView" (update)="onPIDClick($event);">
        </app-obd-pid-view>
      </div>
    </div>
    <!-- <div class="row no-gutters align-items-center">
      <div class="col-md-12">
        <app-time-seeker [selectedDevice]="vehicle.deviceId" [tsTime]="startTime" [teTime]="endTime"
          (onTimeSel)="onTimeSelection($event)"></app-time-seeker>
      </div>
    </div> -->
  </div>
  <!-- map column -->
  <div class="col-md-8 p-0 main-padding smooth">
    <!-- message type list start -->
    <div class="message-list-toggle">
      @if (!isDrawerOpen) {
<span ngbTooltip="Expand Message List"
        placement="left" (click)="toggleMessageDrawer()"
        class="openbtn badge badge-secondary">
        <i class="fa fa-angle-double-left font-14" aria-hidden="true"></i>
      </span>
}
      @if (isDrawerOpen) {
<span ngbTooltip="Collapse Message List"
        placement="right" (click)="toggleMessageDrawer()"
        class="openbtn badge badge-secondary">
        <i class="fa fa-angle-double-right font-14" aria-hidden="true"></i>
      </span>
}
    </div>
    <div class="message-list-drawer" [class.open]="isDrawerOpen">
      @if (isDrawerOpen) {
<div class="message-list-container">
        @if (!messagesLoading && messages.length) {
<ul class="message-list">
          @for (obj of messages; track obj) {
<li>
            <a class="message-link"
              [class.selected]="selectedMessages.includes(obj.message)"
              (click)="plotMessageMarkers(obj)">
              <div class="label-color" [ngStyle]="{backgroundColor: obj.color}"></div>
              <span class="mr-3">{{obj.message}}</span>
              <span class="text-bold pull-right">{{obj.count}}</span>
            </a>
          </li>
}
        </ul>
}
        @if (messagesLoading) {
<div class="text-center my-4">
          <img src="../../../assets/img/darby_loader_small.gif"/>
        </div>
}
        @if (!messagesLoading && !messages.length) {
<p class="message-info">
          There are no messages at the moment.
        </p>
}
      </div>
}
    </div>
    <!-- message type list end -->
    <div #gmap style="width:100%;height: 35vh;" id="gmap"></div>
    <div #infowindowData class="infowindowData">
      @if (latencyData?.ingestionTimestamp) {

        <p class="mb-0 font-14">GsmStrength: {{latencyData.gsmStrength? latencyData.gsmStrength : '--'}}</p>
        <p class="mb-0 font-14">Event Time: {{$safeNavigationMigration(latencyData?.eventTime) | date:dateFormat}}</p>
        <p class="mb-0 font-14">Ingestion Time: {{$safeNavigationMigration(latencyData?.ingestionTimestamp) | date:dateFormat}}</p>
      
}
    </div>
    <hr style="margin: 0;">
    @if (!noDevices) {
<app-obdpid [params]="graphContainerParams"></app-obdpid>
}
  </div>
</div>

<!-- message JSON popup start -->
<div id="messageJSON" data-keyboard="false" data-backdrop="static" class="modal fade">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content bd-0 bg-transparent overflow-hidden">
      <div class="modal-body p-0">
        <div class="row no-gutters">
          <div class="col-12">
            <span class="pull-right closeBtn" data-dismiss="modal">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
            <div class="modal-box p-3 mt-4">
              <div class="reply-header">
                <h5>Message Detail</h5>
              </div>
              @if (messageJsonLoader) {
<div class="text-center mt-5 pt-5">
                <img src="../../../assets/img/darby_loader_small.gif"/>
              </div>
}
              @if (!messageJsonLoader) {
<div class="scrollable-modal-body">
                <pre class="bench-device-data mt-4" [innerHTML]="messageJsonFormattedString"> </pre>
              </div>
}
              <div class="row pt-3">
                <div class="col-lg-6"></div>
                <div class="col-lg-6 sm-form-design">
                  <div class="login-buttons width100 text-right">
                    <button class="btn btn-outline-primary small-screen-btn mr-2" (click)="downloadMessageJSON()">Download JSON</button>
                    <button class="btn btn-outline-secondary small-screen-btn mr-2" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- message JSON popup end -->

<!-- start popup go to reports -->
<div id="goToReportsModal" data-keyboard="false" data-backdrop="static" class="modal fade">
  <div class="modal-dialog" role="document">
    <div class="modal-content bd-0 bg-transparent overflow-hidden">
      <div class="modal-body p-0">
        <div class="row no-gutters">
          <div class="col-12">
            <span #closeReportsModal class="pull-right closeBtn" data-dismiss="modal">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
            <div class="modal-box p-3 mt-4">
              <div class="reply-header">
                <h5>Go to Reports</h5>
              </div>
              @if (customLoader) {
<div class="text-center tooltip-address-text">
                <img src="../../../assets/img/darby_loader_small.gif"/>
              </div>
}
              <div class="row no-gutters mt-3">
                <div class="col-sm-12">
                  <div class="card">
                    <ul class="list-group list-group-flush" style="max-height: 400px; overflow: auto;">
                      <li class="list-group-item">
                        <form #reportSearchForm="ngForm">
                          <input
                            #reportSearch
                            type="text"
                            class="form-control p-2"
                            placeholder="Search Report"
                            (click)="$event.stopPropagation();"
                            (keyup)="filterReport($event)"
                          />
                        </form>
                      </li>
                      @for (data of reports; track data) {
<li class="list-group-item text-left cursor-pointer"
                       
                        (click)="redirectToReports(data)">
                        <i class="fa fa-bar-chart report-icon"></i> {{data.name}}
                      </li>
}
                      @if (!reports.length) {
<li class="list-group-item text-center">
                        <b>No reports found</b>
                      </li>
}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- end popup go to reports -->
<button id="goToReportsBtn" type="button" hidden data-toggle="modal" data-target="#goToReportsModal"></button>